<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li>Course Category</li>
            </ul>
            <h2>Course Category</h2>
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>

<div class="courses-area ptb-100">
    <div class="container">
        <div class="odemy-grid-sorting row align-items-center">
            <div class="col-lg-6 col-md-6 result-count">
                <p>We found <span class="count">{{courseCategoryData.length}}</span> course category available for you
                </p>
            </div>
            <div class="col-lg-6 col-md-6 ordering">
                <div class="select-box">
                    <label>Sort By:</label>
                    <select>
                        <option>Default</option>
                        <option>Popularity</option>
                        <option>Latest</option>
                        <option>Price: low to high</option>
                        <option>Price: high to low</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let item of courseCategoryData">
                <div class="single-courses-box bg-color" (click)="getSubCategory(item)">
                    <div class="courses-image">
                        <a class="d-block image">
                            <img [src]="imageUrl+item.imagePath" alt="image">
                        </a>
                    </div>
                    <div class="courses-content">
                        <h3><a>{{ item.coursesCategoryName }}</a></h3>
                        <p>{{item.coursesCategoryDescription}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>